/** @param {(typeof import('./segmentedTabsTokens.js').APPEARANCE)['default']} t */
export function getSegmentedTabSx(t) {
  return {
    flex: 'none',
    flexShrink: 0,
    minHeight: t.tabMinHeight ?? 28,
    minWidth: 0,
    width: 'fit-content',
    borderRadius: `${t.tabRadiusPx}px`,
    padding: t.tabPadding ?? '4px 8px',
    gap: '6px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    color: t.textInactive,
    fontFamily: 'var(--app-font-sans)',
    fontWeight: 590,
    fontSize: t.tabFontSize,
    lineHeight: t.tabLineHeight,
    letterSpacing: 0,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    transition: (theme) =>
      theme.transitions.create(['background-color', 'box-shadow', 'color'], {
        duration: theme.transitions.duration.shortest,
      }),
    '& > .MuiTab-icon': {
      margin: 0,
      color: 'inherit',
      width: 20,
      height: 20,
      flexShrink: 0,
    },
    '& > .MuiTab-icon svg': { width: 20, height: 20, color: 'inherit' },
    '&.Mui-selected': {
      color: t.textActive,
      bgcolor: t.activeBg,
      boxShadow: t.activeShadow,
      width: 'fit-content',
      padding: t.tabPadding ?? '4px 8px',
    },
    '&:focus-visible': {
      boxShadow: (theme) => `inset 0 0 0 2px ${theme.palette.primary.main}`,
    },
    '&.Mui-selected:focus-visible': {
      boxShadow: (theme) => `${t.activeShadow}, inset 0 0 0 2px ${theme.palette.primary.main}`,
    },
  }
}
